import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from '../../../PageLayout/CheckBox';
import Misc from '../../../../misc';
import DropDown from '../../../Generic/dropDown2';
import Dropzone from 'react-dropzone';
import { PRODUCT_SORT_OPTIONS } from './NewInstallationOverlay.js';
import { SCREENS } from './NewInstallationOverlay.js';
import { getSizedThumbnailUrl } from './../../../../utilities/helpers';
export default function () {
    function onClick1() {
        this.setState({ screen: SCREENS.Assignment });
    }
    function onClick2() {
        this.setState({ screen: SCREENS.Gallery });
    }
    function onChange3(e) {
        this.setState({ name: e.target.value });
    }
    function onChange4(e) {
        this.setState({ description: e.target.value });
    }
    function onClick5() {
        this.setState({ showUnitDDL: true });
    }
    function onClickOutside6() {
        this.setState({ showUnitDDL: false });
    }
    function onSelect7(val) {
        this.setState({
            showUnitDDL: false,
            unit: val
        });
    }
    function onChecked8() {
        this.setState({ forQuotingTool: !this.state.forQuotingTool });
    }
    function onChecked9() {
        this.toggleVisualizer('kv');
    }
    function onChecked10() {
        this.toggleVisualizer('bv');
    }
    function onChecked11() {
        this.setState({ hideUnitLabel: !this.state.hideUnitLabel });
    }
    function onChecked12() {
        this.setState({ automaticAdd: !this.state.automaticAdd });
    }
    function onChecked13() {
        this.setState({
            customerAdd: !this.state.customerAdd,
            employeeOnly: !this.state.customerAdd || this.state.employeeOnly
        });
    }
    function onChecked14() {
        this.setState({ employeeOnly: !this.state.employeeOnly });
    }
    function onChecked15() {
        this.setState({ hideQuantity: !this.state.hideQuantity });
    }
    function onChange16(e) {
        this.setState({ defaultQuantity: e.target.value });
    }
    function onClick17(group, groupIndex) {
        this.setState({ activeGroup: group }, this.refreshFilterIcons);
    }
    function repeatGroup18(group, groupIndex) {
        return [React.createElement('li', {
                'className': 'fc-cat__list-item ' + (group === this.state.activeGroup ? 'fc-cat__list-item--active' : ''),
                'onClick': onClick17.bind(this, group, groupIndex),
                'key': '76991'
            }, group.name)];
    }
    function onChange19(e) {
        this.setState({ productFilter: e.target.value });
    }
    function onClick20() {
        this.state.allFilterOptions && this.state.allFilterOptions.length > 0 && this.setState({
            allFilterOptionsVisible: true,
            sortOptionsVisible: false,
            materialFilterOptionsVisible: false,
            colorFilterOptionsVisible: false
        });
    }
    function onClick21() {
        this.state.materialFilterOptions && this.state.materialFilterOptions.length > 0 && this.setState({
            materialFilterOptionsVisible: true,
            sortOptionsVisible: false,
            colorFilterOptionsVisible: false,
            allFilterOptionsVisible: false
        });
    }
    function onClick22() {
        this.setState({
            sortOptionsVisible: true,
            materialFilterOptionsVisible: false,
            colorFilterOptionsVisible: false,
            allFilterOptionsVisible: false
        });
    }
    function onClick23() {
        this.state.colorFilterOptions && this.state.colorFilterOptions.length > 0 && this.setState({
            colorFilterOptionsVisible: true,
            sortOptionsVisible: false,
            materialFilterOptionsVisible: false,
            allFilterOptionsVisible: false
        });
    }
    function onChecked24(feature, featureIndex, selectedFeatures) {
        this.toggleFeature(feature.fabricatorData.id);
    }
    function scopeSelectedFeatures25(feature, featureIndex) {
        var selectedFeatures = this.state.features;
        return [React.createElement('li', {
                'className': 'fc-filters__list-item',
                'key': '120471'
            }, React.createElement(CheckBox, {
                'type': 'tiny',
                'text': this.cleanProductName(feature),
                'checked': selectedFeatures.indexOf(feature.fabricatorData.id) >= 0,
                'onChecked': onChecked24.bind(this, feature, featureIndex, selectedFeatures)
            }))];
    }
    function repeatFeature26(feature, featureIndex, selectedFeatures) {
        return scopeSelectedFeatures25.apply(this, [
            feature,
            featureIndex
        ]);
    }
    function onChecked27() {
        this.setState({ galleryEnabled: !this.state.galleryEnabled });
    }
    function onClick28(image, imageIndex) {
        this.handleSetFeatured(image);
    }
    function onClick29(image, imageIndex) {
        this.handleMakeDefault(image);
    }
    function onClick30(image, imageIndex) {
        this.handleDeleteGalleryImage(image);
    }
    function repeatImage31(image, imageIndex) {
        return [React.createElement('li', {
                'className': 'fc-gallery__list-item',
                'key': '154871'
            }, React.createElement('span', {
                'className': 'ui-house fc-gallery__list-item-house ' + (image.featured ? 'ui-house--active' : ''),
                'onClick': onClick28.bind(this, image, imageIndex)
            }, 'Featured'), React.createElement('div', {
                'className': 'fc-gallery__list-item-image',
                'style': { backgroundImage: 'url(\'' + getSizedThumbnailUrl(image.url, 150) + '\')' }
            }), React.createElement('span', {
                'className': 'ui-star fc-gallery__list-item-star ' + (image.default ? 'ui-star--active' : ''),
                'onClick': onClick29.bind(this, image, imageIndex)
            }, image.default ? '' : 'Make ', 'Default'), React.createElement('button', {
                'className': 'ui-icon-remove2 fc-gallery__list-item-remove',
                'onClick': onClick30.bind(this, image, imageIndex)
            }))];
    }
    function onClick32() {
        this.setState({ sortOptionsVisible: false });
    }
    function onClick33() {
        this.setState({
            productSortBy: PRODUCT_SORT_OPTIONS.Name,
            sortOptionsVisible: false
        });
    }
    function onClick34() {
        this.setState({
            productSortBy: PRODUCT_SORT_OPTIONS.Price,
            sortOptionsVisible: false
        });
    }
    function onClick35(mfo, hasMFO) {
        this.setState({ materialFilterOptionsVisible: false });
    }
    function onClick36(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters) {
        this.toggleFilter(material.id);
    }
    function onClick37(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters) {
        this.toggleExpand(material.id);
    }
    function onClick38(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters) {
        this.toggleFilter(material.id);
    }
    function onClick39(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters, item, itemIndex) {
        this.toggleFilter(item.id);
    }
    function repeatItem40(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters, item, itemIndex) {
        return [React.createElement('div', {
                'className': 'stone-filter-sub-lir',
                'key': '211011'
            }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                'className': 'radio-ring',
                'onClick': onClick39.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters, item, itemIndex)
            }, selectedFilters.includes(item.id) ? React.createElement('div', {
                'className': 'radio-check',
                'key': '21538'
            }) : null), React.createElement('h1', {}, _.trim(item.displayText || item.value))))];
    }
    function scopeSelectedFiltersExpandedFilters41(mfo, hasMFO, material, materialIndex) {
        var selectedFilters = this.state.selectedFilters;
        var expandedFilters = this.state.expandedFilters;
        return [
            !material.items || material.items.length == 0 ? React.createElement('li', {
                'className': 'stone-filter-lir-wrapper',
                'key': '189791'
            }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                'className': 'radio-ring',
                'onClick': onClick36.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters)
            }, selectedFilters.includes(material.id) ? React.createElement('div', {
                'className': 'radio-check',
                'key': '19489'
            }) : null), React.createElement('h1', {}, _.trim(material.displayText || material.value)))) : null,
            material.items && material.items.length > 0 ? React.createElement.apply(this, [
                'li',
                {
                    'className': 'stone-filter-lir-wrapper',
                    'style': { height: 'auto' },
                    'key': '189793'
                },
                React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                    'className': 'radio-ring',
                    'onClick': onClick37.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters)
                }, React.createElement('div', { 'className': expandedFilters.includes(material.id) ? 'radio-arrow-open' : 'radio-arrow-closed' })), React.createElement('h1', {}, _.trim(material.displayText || material.value))),
                expandedFilters.includes(material.id) ? React.createElement('div', {
                    'className': 'stone-filter-sub-lir',
                    'key': '20451'
                }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                    'className': 'radio-ring',
                    'onClick': onClick38.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters)
                }, selectedFilters.includes(material.id) ? React.createElement('div', {
                    'className': 'radio-check',
                    'key': '20759'
                }) : null), React.createElement('h1', {}, _.trim(material.displayText || material.value)))) : null,
                expandedFilters.includes(material.id) ? _.map(material.items, repeatItem40.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters)) : null
            ]) : null
        ];
    }
    function repeatMaterial42(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters) {
        return scopeSelectedFiltersExpandedFilters41.apply(this, [
            mfo,
            hasMFO,
            material,
            materialIndex
        ]);
    }
    function scopeMfoHasMFO43() {
        var mfo = this.state.materialFilterOptions;
        var hasMFO = mfo && mfo.length > 0;
        return React.createElement('div', {
            'className': 'feature-creation__popup feature-creation__popup--material',
            'key': '18272'
        }, React.createElement('div', { 'className': 'feature-creation__popup-header' }, 'Material'), React.createElement('button', {
            'className': 'ui-icon-close feature-creation__popup-close',
            'onClick': onClick35.bind(this, mfo, hasMFO)
        }), React.createElement('div', { 'className': 'feature-creation__popup-body' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-materials' },
            !hasMFO ? React.createElement('div', { 'key': '18843' }, '\r\n                            No Material Filters Present\r\n                        ') : null,
            _.map(this.state.materialFilterOptions, repeatMaterial42.bind(this, mfo, hasMFO))
        ])));
    }
    function onClick44(cfo, hascfo) {
        this.setState({ colorFilterOptionsVisible: false });
    }
    function onClick45(cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters) {
        this.toggleFilter(color.id);
    }
    function onClick46(cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters) {
        this.toggleExpand(color.id);
    }
    function onClick47(cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters) {
        this.toggleFilter(color.id);
    }
    function onClick48(cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters, item, itemIndex) {
        this.toggleFilter(item.id);
    }
    function repeatItem49(cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters, item, itemIndex) {
        return [React.createElement('div', {
                'className': 'stone-filter-sub-lir',
                'key': '249641'
            }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                'className': 'radio-ring',
                'onClick': onClick48.bind(this, cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters, item, itemIndex)
            }, selectedFilters.includes(item.id) ? React.createElement('div', {
                'className': 'radio-check',
                'key': '25387'
            }) : null), React.createElement('h1', {}, _.trim(item.displayText || item.value), ' ', React.createElement('span', {
                'className': 'fc-color-patch',
                'style': { backgroundColor: item.value }
            }))))];
    }
    function scopeSelectedFiltersExpandedFilters50(cfo, hascfo, color, colorIndex) {
        var selectedFilters = this.state.selectedFilters;
        var expandedFilters = this.state.expandedFilters;
        return [
            !color.items || color.items.length == 0 ? React.createElement('li', {
                'className': 'stone-filter-lir-wrapper',
                'key': '227451'
            }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                'className': 'radio-ring',
                'onClick': onClick45.bind(this, cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters)
            }, selectedFilters.includes(color.id) ? React.createElement('div', {
                'className': 'radio-check',
                'key': '23240'
            }) : null), React.createElement('h1', {}, _.trim(color.displayText || color.value), ' ', React.createElement('span', {
                'className': 'fc-color-patch',
                'style': { backgroundColor: color.value }
            })))) : null,
            color.items && color.items.length > 0 ? React.createElement.apply(this, [
                'li',
                {
                    'className': 'stone-filter-lir-wrapper',
                    'style': { height: 'auto' },
                    'key': '227453'
                },
                React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                    'className': 'radio-ring',
                    'onClick': onClick46.bind(this, cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters)
                }, React.createElement('div', { 'className': expandedFilters.includes(color.id) ? 'radio-arrow-open' : 'radio-arrow-closed' })), React.createElement('h1', {}, _.trim(color.displayText || color.value))),
                expandedFilters.includes(color.id) ? React.createElement('div', {
                    'className': 'stone-filter-sub-lir',
                    'key': '24252'
                }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                    'className': 'radio-ring',
                    'onClick': onClick47.bind(this, cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters)
                }, selectedFilters.includes(color.id) ? React.createElement('div', {
                    'className': 'radio-check',
                    'key': '24554'
                }) : null), React.createElement('h1', {}, _.trim(color.displayText || color.value), ' ', React.createElement('span', {
                    'className': 'fc-color-patch',
                    'style': { backgroundColor: color.value }
                })))) : null,
                expandedFilters.includes(color.id) ? _.map(color.items, repeatItem49.bind(this, cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters)) : null
            ]) : null
        ];
    }
    function repeatColor51(cfo, hascfo, color, colorIndex, selectedFilters, expandedFilters) {
        return scopeSelectedFiltersExpandedFilters50.apply(this, [
            cfo,
            hascfo,
            color,
            colorIndex
        ]);
    }
    function scopeCfoHascfo52() {
        var cfo = this.state.colorFilterOptions;
        var hascfo = cfo && cfo.length > 0;
        return React.createElement('div', {
            'className': 'feature-creation__popup feature-creation__popup--color',
            'key': '22056'
        }, React.createElement('div', { 'className': 'feature-creation__popup-header' }, 'color'), React.createElement('button', {
            'className': 'ui-icon-close feature-creation__popup-close',
            'onClick': onClick44.bind(this, cfo, hascfo)
        }), React.createElement('div', { 'className': 'feature-creation__popup-body' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-materials' },
            !hascfo ? React.createElement('div', { 'key': '22612' }, '\r\n                            No Color Filters Present\r\n                        ') : null,
            _.map(this.state.colorFilterOptions, repeatColor51.bind(this, cfo, hascfo))
        ])));
    }
    function onClick53(mfo, hasMFO) {
        this.setState({ allFilterOptionsVisible: false });
    }
    function onClick54(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters) {
        this.toggleFilter(material.id);
    }
    function onClick55(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters) {
        this.toggleExpand(material.id);
    }
    function onClick56(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters, item, itemIndex) {
        this.toggleFilter(item.id);
    }
    function repeatItem57(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters, item, itemIndex) {
        return [React.createElement('div', {
                'className': 'stone-filter-sub-lir',
                'key': '282181'
            }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                'className': 'radio-ring',
                'onClick': onClick56.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters, item, itemIndex)
            }, selectedFilters.includes(item.id) ? React.createElement('div', {
                'className': 'radio-check',
                'key': '28655'
            }) : null), React.createElement('h1', {}, _.trim(item.displayText || item.value))))];
    }
    function scopeSelectedFiltersExpandedFilters58(mfo, hasMFO, material, materialIndex) {
        var selectedFilters = this.state.selectedFilters;
        var expandedFilters = this.state.expandedFilters;
        return [
            !material.items || material.items.length == 0 ? React.createElement('li', {
                'className': 'stone-filter-lir-wrapper',
                'key': '267511'
            }, React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                'className': 'radio-ring',
                'onClick': onClick54.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters)
            }, selectedFilters.includes(material.id) ? React.createElement('div', {
                'className': 'radio-check',
                'key': '27256'
            }) : null), React.createElement('h1', {}, _.trim(material.displayText || material.value)))) : null,
            material.items && material.items.length > 0 ? React.createElement.apply(this, [
                'li',
                {
                    'className': 'stone-filter-lir-wrapper',
                    'style': { height: 'auto' },
                    'key': '267513'
                },
                React.createElement('div', { 'className': 'stone-filter-lir' }, React.createElement('div', {
                    'className': 'radio-ring',
                    'onClick': onClick55.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters)
                }, React.createElement('div', { 'className': expandedFilters.includes(material.id) ? 'radio-arrow-open' : 'radio-arrow-closed' })), React.createElement('h1', {}, _.trim(material.displayText || material.value))),
                expandedFilters.includes(material.id) ? _.map(material.items, repeatItem57.bind(this, mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters)) : null
            ]) : null
        ];
    }
    function repeatMaterial59(mfo, hasMFO, material, materialIndex, selectedFilters, expandedFilters) {
        return scopeSelectedFiltersExpandedFilters58.apply(this, [
            mfo,
            hasMFO,
            material,
            materialIndex
        ]);
    }
    function scopeMfoHasMFO60() {
        var mfo = this.state.allFilterOptions;
        var hasMFO = mfo && mfo.length > 0;
        return React.createElement('div', {
            'className': 'feature-creation__popup feature-creation__popup--properties',
            'key': '25981'
        }, React.createElement('div', { 'className': 'feature-creation__popup-header' }, this.state.selectedFilterGroup ? this.state.selectedFilterGroup.name : 'All Filter Options'), React.createElement('button', {
            'className': 'ui-icon-close feature-creation__popup-close',
            'onClick': onClick53.bind(this, mfo, hasMFO)
        }), React.createElement('div', { 'className': 'feature-creation__popup-body' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-materials' },
            !hasMFO ? React.createElement('div', { 'key': '26624' }, '\r\n                            No Filters Present\r\n                        ') : null,
            _.map(this.state.allFilterOptions, repeatMaterial59.bind(this, mfo, hasMFO))
        ])));
    }
    function onClick61() {
        this.setState({ screen: SCREENS.Gallery });
    }
    return React.createElement('div', { 'className': 'ui-popup ui-popup--large' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, this.state.id >= 0 ? 'Edit "' + this.state.name + '"' : 'New Product', ' Installation')), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('ul', { 'className': 'ui-breadcrumbs ui-breadcrumbs--inline' }, React.createElement('li', {
        'className': 'ui-breadcrumbs-link ' + (this.state.screen === SCREENS.Assignment ? 'ui-breadcrumbs-link--selected' : ''),
        'onClick': onClick1.bind(this)
    }, 'Assignment'), React.createElement('li', {
        'className': 'ui-breadcrumbs-link ' + (this.state.screen === SCREENS.Gallery ? 'ui-breadcrumbs-link--selected' : ''),
        'onClick': onClick2.bind(this)
    }, 'Gallery')), React.createElement('div', { 'className': 'feature-creation' }, React.createElement('aside', { 'className': 'feature-creation__aside scrollable-list' }, this.state.nameError ? React.createElement('div', {
        'className': 'feature-creation__aside-error',
        'key': '1424'
    }, this.state.nameError) : null, React.createElement('div', { 'className': 'feature-creation__aside-block' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Installation Name'), React.createElement('input', {
        'className': 'generic-popup-textbox',
        'placeholder': 'Installation Name',
        'maxLength': 255,
        'value': this.state.name,
        'onChange': onChange3.bind(this)
    })), this.state.descError ? React.createElement('div', {
        'className': 'feature-creation__aside-error',
        'key': '1894'
    }, this.state.descError) : null, React.createElement('div', { 'className': 'feature-creation__aside-block' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Description'), React.createElement('textarea', {
        'className': 'generic-popup-textarea',
        'placeholder': 'Description',
        'maxLength': 255,
        'value': this.state.description,
        'onChange': onChange4.bind(this)
    })), this.state.thumbError ? React.createElement('div', {
        'className': 'feature-creation__aside-error',
        'key': '2381'
    }, this.state.thumbError) : null, React.createElement(Dropzone, {
        'accept': 'image/jpeg, image/png, image/svg+xml',
        'onDrop': this.onDrop,
        'className': 'feature-creation__aside-thumbnail',
        'acceptStyle': {
            'boxShadow': '0 0 1em green inset',
            'backgroundColor': 'rgba(0,192,0,0.3)'
        },
        'rejectStyle': {
            'boxShadow': '0 0 1em red inset',
            'backgroundColor': 'rgba(192,0,0,0.3)'
        }
    }, this.state.thumbnailImageUrl ? [
        React.createElement('span', {
            'className': 'generic-popup-title',
            'key': '29511'
        }, 'Update Visualizer Image Thumbnail'),
        React.createElement('div', {
            'className': 'feature-creation__aside-thumbnail-image',
            'style': { backgroundImage: 'url(\'' + this.state.thumbnailImageUrl + '\')' },
            'key': '29513'
        })
    ] : null, !this.state.thumbnailImageUrl ? [
        React.createElement('span', {
            'className': 'generic-popup-title',
            'key': '33061'
        }, 'Add Visualizer Image Thumbnail'),
        React.createElement('div', {
            'className': 'feature-creation__aside-thumbnail-image',
            'key': '33063'
        })
    ] : null, React.createElement('span', { 'className': 'generic-popup-title' }, 'Drag and Drop Files'), React.createElement('div', { 'className': 'feature-creation__aside-thumbnail-subtitle-subtext' }, 'Supported File Formats: JPG, PNG and SVG')), React.createElement('div', { 'className': 'feature-creation__aside-block' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Measurement Units'), React.createElement('div', { 'className': 'fc-inst__select select2 ' + (this.state.showUnitDDL ? 'select2--active' : '') }, React.createElement('div', {
        'className': 'select2-value',
        'onClick': onClick5.bind(this)
    }, this.state.unit.unit), React.createElement(DropDown, {
        'selected': this.state.unit,
        'items': this.state.unitList,
        'onClickOutside': onClickOutside6.bind(this),
        'onSelect': onSelect7.bind(this),
        'onAddNew': this.addNewUnit,
        'addNewItemName': 'Unit'
    }))), React.createElement('div', { 'className': 'feature-creation__aside-footer' }, React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.forQuotingTool,
        'text': 'Enable for Quoting Tool',
        'onChecked': onChecked8.bind(this)
    }), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.hasVisualizer('kv'),
        'text': 'Enable for Kitchen Visualizer',
        'onChecked': onChecked9.bind(this)
    }), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.hasVisualizer('bv'),
        'text': 'Enable for Bathroom Visualizer',
        'onChecked': onChecked10.bind(this)
    }), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.hideUnitLabel,
        'text': 'Hide Unit Label',
        'onChecked': onChecked11.bind(this)
    }), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.automaticAdd,
        'text': 'Automatically Add with Product',
        'onChecked': onChecked12.bind(this)
    }), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.customerAdd,
        'text': 'Add Labor Customer',
        'onChecked': onChecked13.bind(this)
    }), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.employeeOnly,
        'disabled': this.state.customerAdd,
        'text': 'Add Labor Installer',
        'onChecked': onChecked14.bind(this)
    }), React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.hideQuantity,
        'text': 'Hide Quantity',
        'onChecked': onChecked15.bind(this)
    }), this.state.hideQuantity ? React.createElement('div', {
        'className': 'feature-creation__aside-footer-quantity',
        'key': '6946'
    }, React.createElement('div', {}, 'Default Quantity'), React.createElement('input', {
        'type': 'text',
        'placeholder': '1',
        'className': 'generic-popup-textbox',
        'value': this.state.defaultQuantity,
        'onChange': onChange16.bind(this)
    })) : null)), React.createElement('div', { 'className': 'feature-creation__content' }, this.state.screen == SCREENS.Assignment ? React.createElement('div', {
        'className': 'fc-filter',
        'key': '7424'
    }, React.createElement('div', { 'className': 'fc-cat' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Product Groups'), React.createElement.apply(this, [
        'ul',
        { 'className': 'fc-cat__list' },
        _.map(this.props.featureGroups, repeatGroup18.bind(this))
    ])), React.createElement('div', { 'className': 'fc-filters fc-filters--with-header' }, React.createElement('div', { 'className': 'fc-filters__header' }, React.createElement('div', { 'className': 'fc-filters__header-input' }, React.createElement('input', {
        'className': 'generic-popup-textbox',
        'placeholder': 'search',
        'value': this.state.productFilter,
        'onChange': onChange19.bind(this)
    })), React.createElement('div', { 'className': 'fc-filters__header-buttons' }, React.createElement('span', {
        'className': 'ui-icon-filter ui-icon-filter--properties ' + (this.state.allFilterOptionsVisible ? 'ui-icon-filter--active' : '') + ' ' + (!(this.state.allFilterOptions && this.state.allFilterOptions.length > 0) ? 'disabled' : ''),
        'onClick': onClick20.bind(this)
    }, '+Filters'), React.createElement('span', {
        'className': 'ui-icon-filter ui-icon-filter--material ' + (this.state.materialFilterOptionsVisible ? 'ui-icon-filter--active' : '') + ' ' + (!(this.state.materialFilterOptions && this.state.materialFilterOptions.length > 0) ? 'disabled' : ''),
        'onClick': onClick21.bind(this)
    }, 'Material'), React.createElement('span', {
        'className': 'ui-icon-filter ui-icon-filter--' + this.state.productSortBy.toLowerCase() + ' ' + (this.state.sortOptionsVisible ? 'ui-icon-filter--active' : ''),
        'onClick': onClick22.bind(this)
    }, this.state.productSortBy), React.createElement('span', {
        'className': 'ui-icon-filter ui-icon-filter--color ' + (this.state.colorFilterOptionsVisible ? 'ui-icon-filter--active' : '') + ' ' + (!(this.state.colorFilterOptions && this.state.colorFilterOptions.length > 0) ? 'disabled' : ''),
        'onClick': onClick23.bind(this)
    }, 'Color'))), React.createElement('div', { 'className': 'fc-filters__sub-header' }, React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.checkAllFeatures,
        'text': 'All Products',
        'onChecked': this.allProductsClicked
    })), !this.state.activeGroup ? React.createElement('div', {
        'className': 'fc-filters__text',
        'key': '11269'
    }, React.createElement('div', { 'className': 'fc-installation__empty' }, '\r\n                                Select a Product Group\r\n                            ')) : null, this.state.activeGroup && this.state.activeGroup.features.length == 0 ? React.createElement('div', {
        'className': 'fc-filters__text',
        'key': '11547'
    }, React.createElement('div', { 'className': 'fc-installation__empty' }, '\r\n                                Product Group has no Products, it should not have been visible\r\n                            ')) : null, this.state.activeGroup && this.state.activeGroup.features.length > 0 ? React.createElement.apply(this, [
        'ul',
        {
            'className': 'fc-filters__list',
            'key': '11911'
        },
        _.map(this.applyProductSort(this.applyProductFilters(this.getGroupsFeatures(this.state.activeGroup))), repeatFeature26.bind(this))
    ]) : null)) : null, this.state.screen == SCREENS.Gallery ? React.createElement('div', {
        'className': 'fc-gallery',
        'key': '12903'
    }, React.createElement(CheckBox, {
        'type': 'tiny',
        'checked': this.state.galleryEnabled,
        'text': 'Enable for Image Gallery',
        'onChecked': onChecked27.bind(this)
    }), this.state.galleryImages.length == 0 ? React.createElement(Dropzone, {
        'accept': 'image/jpeg, image/png, image/svg+xml',
        'onDrop': this.onGalleryDrop,
        'className': 'fc-gallery__upload',
        'acceptStyle': {
            'boxShadow': '0 0 1em green inset',
            'backgroundColor': 'rgba(0,192,0,0.3)'
        },
        'rejectStyle': {
            'boxShadow': '0 0 1em red inset',
            'backgroundColor': 'rgba(192,0,0,0.3)'
        },
        'key': '13264'
    }, React.createElement('div', { 'className': 'fc-gallery__upload-image' }), React.createElement('div', { 'className': 'fc-gallery__upload-text' }, React.createElement('p', {}, 'Drag and Drop Files'), React.createElement('p', {}, 'Supported File Formats: JPG, PNG and SVG')), React.createElement('span', { 'className': 'fc-gallery__upload-browser' }, '+ Select files from Browser')) : null, this.state.galleryImages.length > 0 ? React.createElement.apply(this, [
        'ul',
        {
            'className': 'fc-gallery__list',
            'key': '14224'
        },
        React.createElement('li', { 'className': 'fc-gallery__list-item fc-gallery__list-item-upload' }, React.createElement(Dropzone, {
            'accept': 'image/jpeg, image/png, image/svg+xml',
            'onDrop': this.onGalleryDrop,
            'className': 'fc-gallery__upload',
            'acceptStyle': {
                'boxShadow': '0 0 1em green inset',
                'backgroundColor': 'rgba(0,192,0,0.3)'
            },
            'rejectStyle': {
                'boxShadow': '0 0 1em red inset',
                'backgroundColor': 'rgba(192,0,0,0.3)'
            }
        }, React.createElement('div', { 'className': 'fc-gallery__upload-image' }), React.createElement('div', { 'className': 'fc-gallery__upload-text' }, React.createElement('p', {}, 'Drag and Drop Files'), React.createElement('p', {}, 'Supported File Formats: JPG, PNG and SVG')), React.createElement('span', { 'className': 'fc-gallery__upload-browser' }, '+ Select files from Browser'))),
        _.map(this.state.galleryImages, repeatImage31.bind(this))
    ]) : null) : null), this.state.sortOptionsVisible || this.state.materialFilterOptionsVisible || this.state.colorFilterOptionsVisible || this.state.allFilterOptionsVisible ? React.createElement('div', {
        'onClick': this.hideFilterPopup,
        'className': 'feature-creation__popup--overlay',
        'key': '16673'
    }) : null, this.state.sortOptionsVisible ? React.createElement('div', {
        'className': 'feature-creation__popup feature-creation__popup--price',
        'key': '16979'
    }, React.createElement('div', { 'className': 'feature-creation__popup-header' }, this.state.productSortBy), React.createElement('button', {
        'className': 'ui-icon-close feature-creation__popup-close',
        'onClick': onClick32.bind(this)
    }), React.createElement('div', { 'className': 'feature-creation__popup-body' }, React.createElement('ul', { 'className': 'fc-sortlist' }, React.createElement('li', {
        'className': 'fc-sortlist__item fc-sortlist__item--name ' + (this.state.productSortBy === PRODUCT_SORT_OPTIONS.Name ? 'fc-sortlist__item--active' : ''),
        'onClick': onClick33.bind(this)
    }, '\r\n                            Sort by name\r\n                        '), React.createElement('li', {
        'className': 'fc-sortlist__item fc-sortlist__item--price ' + (this.state.productSortBy === PRODUCT_SORT_OPTIONS.Price ? 'fc-sortlist__item--active' : ''),
        'onClick': onClick34.bind(this)
    }, '\r\n                            Sort by price\r\n                        ')))) : null, this.state.materialFilterOptionsVisible ? scopeMfoHasMFO43.apply(this, []) : null, this.state.colorFilterOptionsVisible ? scopeCfoHascfo52.apply(this, []) : null, this.state.allFilterOptionsVisible ? scopeMfoHasMFO60.apply(this, []) : null)), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': this.handleCancel
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), this.state.screen == SCREENS.Assignment ? React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': onClick61.bind(this),
        'key': '29408'
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Next')) : null, this.state.screen == SCREENS.Gallery ? React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'key': '29660'
    }, React.createElement('span', {
        'className': 'ui-button-text ui-button--uppercase',
        'onClick': this.handleSave
    }, 'Save')) : null));
}